import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageLoader } from '@/components/feedback/PageLoader';
import { ROUTES } from '@/constants/routes.constants';
import { useGetProfileQuery } from '@/features/auth/services/auth.api';
import { useAuth } from '@/hooks/useAuth';
import { useAppDispatch } from '@/store/hooks';
import { clearCredentials, setUser } from '@/store/slices/auth.slice';

export function ProtectedRoute() {
  const { isAuthenticated, user } = useAuth();
  const dispatch = useAppDispatch();
  const location = useLocation();

  // A persisted token keeps `isAuthenticated` true across a page reload, but the
  // Redux `user` is lost. Fetch it once here so the header/profile-gated UI
  // doesn't silently disappear until the user navigates somewhere that happens
  // to fetch it (e.g. the profile page).
  const { data: profile, isError } = useGetProfileQuery(undefined, {
    skip: !isAuthenticated || Boolean(user),
  });

  useEffect(() => {
    if (profile) dispatch(setUser(profile));
  }, [profile, dispatch]);

  useEffect(() => {
    if (isAuthenticated && !user && isError) dispatch(clearCredentials());
  }, [isAuthenticated, user, isError, dispatch]);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!user) {
    return <PageLoader />;
  }

  return <Outlet />;
}
